import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class RecordTransportVehicle extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/vehicle'
    super(store, path)
  }
}
